import React from 'react'
import './style.css'

/**
* @author
* @function Logo
**/

const Logo = (props) => {
  return(
    <div className="logo">
        <a href="/">Elijah Obominuru</a>
    </div>
   )
 }

export default Logo;